var _path, _rect, _rect2, _ellipse, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 49,
    viewBox: "0 0 34 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7139 4.37662L8.49958 4.37662L8.49958 0.999993C8.49958 0.447708 8.9473 -7.12159e-06 9.49958 -7.07808e-06L25.7139 -5.80082e-06C26.2662 -5.75731e-06 26.7139 0.44771 26.7139 0.999994L26.7139 4.37662Z",
    fill: "#2E7161"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.10742,
    y: 5.81491,
    width: 27,
    height: 26.6656,
    rx: 2.75,
    stroke: "#2E7161",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9.34741,
    width: 19.2143,
    height: 18.5065,
    stroke: "#2E7161"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6071,
    cy: 30.0893,
    rx: 0.607143,
    ry: 0.547078,
    fill: "#2E7161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 33.9188H26.7143V37.2954C26.7143 37.8477 26.2666 38.2954 25.7143 38.2954H9.5C8.94772 38.2954 8.5 37.8477 8.5 37.2954V33.9188Z",
    fill: "#2E7161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice);
export default __webpack_public_path__ + "static/media/device.a33d84faf14e1a18ccddfd0c0edf092a.svg";
export { ForwardRef as ReactComponent };